import * as z from "zod/v4";

export const sendMessagingReply = {
  name: "sendMessagingReply" as const,
  input: z.object({
    conversationId: z.string(),
    source: z.enum(["mobile_message", "marketing"]),
    message: z.string().min(1),
  }),
  output: z.object({ success: z.boolean() }),
};
